import React from "react";
import T from "prop-types";

import { useAuthProvider } from "2g-auth";
import Widget from "2g-widget";
import Buttons, { ButtonsSet } from "2g-buttons";
import Form, { Field, FieldStatic, Inputs, Row, ActionButton } from "2g-form";
import { GridBox } from "2g-layout";

import {
  AnoNe,
  DoplnkoveSluzbyNazev,
  UzivatelInfo,
  Termin,
  ZadostHistorie
} from "b2b/renderers";
import { Zakaznik, Projekt, Produkt, ZdrojFull } from "b2b/renderers/ciselnik";

import ZadostEditaceWidgetTitle from "./ZadostEditaceWidgetTitle";
import ZadostEditaceWidgetTitleDescription from "./ZadostEditaceWidgetTitleDescription";
import useZadostEditaceWidget from "./useZadostEditaceWidget";
import useMessages from "./i18n/useMessages";

export function ZadostEditaceWidget({ zadost, loading, reload }) {
  const { userInfo } = useAuthProvider();
  const { buttonSubmit } = useMessages();
  const { formModuleKey, onSubmit } = useZadostEditaceWidget({
    zadost,
    reload
  });
  const disabledPoznamky = !userInfo.isUserInRole([
    "admin",
    "vuz_spravce",
    "vuz_edit"
  ]);
  return (
    <Widget
      collapsable={false}
      title={<ZadostEditaceWidgetTitle zadost={zadost} loading={loading} />}
      titleDescription={
        <ZadostEditaceWidgetTitleDescription
          zadost={zadost}
          loading={loading}
        />
      }
      titleDescriptionOnlyBottom
    >
      <Form moduleKey={formModuleKey} onSubmit={onSubmit} disabled={loading}>
        <GridBox className="b2b-ZadostEditaceWidget-zakladniInformace">
          <FieldStatic label="b2b.zadost-editace-widget.form.field.zakaznik">
            <Zakaznik val={zadost?.zadavatel.zakaznik} />
          </FieldStatic>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.uzivatel">
            <UzivatelInfo val={zadost?.zadavatel.uzivatel} />
          </FieldStatic>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.projekt">
            <Projekt val={zadost?.projekt} />
          </FieldStatic>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.fixni">
            <AnoNe val={zadost?.fixni} />
          </FieldStatic>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.produkt">
            <Produkt val={zadost?.produkt} />
          </FieldStatic>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.zdroj">
            <ZdrojFull val={zadost?.zdroj} />
          </FieldStatic>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.termin">
            <Termin val={zadost} />
          </FieldStatic>
        </GridBox>
        <Row styled>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.doplnkove-sluzby">
            <DoplnkoveSluzbyNazev val={zadost?.doplnkoveSluzby} />
          </FieldStatic>
        </Row>
        <Row styled>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.poznamka-zakaznika">
            {zadost?.poznamkaZakaznik}
          </FieldStatic>
        </Row>
        <Row styled>
          <Field
            component={Inputs.TextArea}
            disabled={disabledPoznamky}
            path="strojvedouci"
            label="b2b.zadost-editace-widget.form.field.poznamka-strojvedouci"
          />
          <Field
            component={Inputs.TextArea}
            disabled={disabledPoznamky}
            path="poznamkaSpravce"
            label="b2b.zadost-editace-widget.form.field.poznamka-spravce"
          />
        </Row>
        <ButtonsSet>
          <ActionButton
            button={Buttons.Primary}
            disabled={disabledPoznamky}
            inverse
            submit
            validate
          >
            {buttonSubmit()}
          </ActionButton>
        </ButtonsSet>
        <Row styled>
          <FieldStatic label="b2b.zadost-editace-widget.form.field.historie">
            <ZadostHistorie val={zadost?.historie} />
          </FieldStatic>
        </Row>
      </Form>
    </Widget>
  );
}

ZadostEditaceWidget.propTypes = {
  zadost: T.object,
  loading: T.bool,
  reload: T.func
};

export default React.memo(ZadostEditaceWidget);
